import { cB as o } from "./ghl-ui.es669.js";
const s = o("popselect-menu", `
 box-shadow: var(--n-menu-box-shadow);
`);
export {
  s as default
};
